module.exports = __webpack_public_path__ + "img/sld_right_arrow.1b3c763e.svg";